<template>
  <section>
    <ModalDistributionAccount
    v-if="isModalDistributionAccountVisible"
    :disabled="isCreateBill"
      :data="data"
      @accept-data="acceptData_AR_UDA01"
      :visible.sync="isModalDistributionAccountVisible"
      :currencyCode="data?.CurrencyCode"
    />

    <b-sidebar
      class="detail-sidebar"
      @hidden="$emit('update:isShow', false)"
      v-model="isShow"
      bg-variant="white"
      right
      backdrop
      shadow
      no-header
      width="60%"
    >
      <template #default="{ hide }">
        <div>
          <div class="sidebar-view-distribution__header d-flex">
            <div class="sidebar-view-distribution__header--title w-50">
              <h4 class="mb-0 p-1 text-primary text-truncate">
                {{ $t("golf_package_course_detail_distribution") }}
              </h4>
            </div>

            <div
              class="sidebar-view-distribution__header--icon w-50 d-flex align-items-center justify-content-end"
            >
             <!--  <ez-icon
                icon="ezAr-icon-trash"
                size="24"
                class="cursor-pointer mx-50"
                color="#EA5455"
                @click="deleteItem(data.Id)"
              /> -->
              <ez-icon
                icon="ezAr-icon-x"
                size="24"
                class="cursor-pointer mx-50"
                color="#114A9F"
                @click="hide"
              />
            </div>
          </div>
          <b-tabs v-model="tabIndex">
            <b-tab :title="$t('ar_common_general_info')">
              <div class="p-1">
                <div class="d-flex justify-content-between">
                  <h6 class="content-title mb-1">
                    {{ $t("ar_voucher_general_information") }}
                  </h6>

                  <ez-icon
                  v-if="isValidPermission(AR_UDA01)"
                    v-b-tooltip.hover
                    icon="ezAr-icon-edit"
                    size="18"
                    color="#114A9F"
                    class="cursor-pointer"
                    :title="$t('golf_common_view_detail')"
                    @click="isModalDistributionAccountVisible = true"
                  ></ez-icon>
                </div>
                <GeneralInfo leftWidth="75px" rightWidth="120px" :list="listGeneral" />
              </div>
              <div class="divider"></div>
              <h5 class="p-1">
                {{ $t("ar_client_list_distribution_account") }}
              </h5>
              <div class="p-1">
                <EzTable
                  :toolbarConfig="{ disableToolbar: true }"
                  :pageConfig="{ disablePagination: true }"
                  :dataSource="data?.ListArDistributionAccount"
                  :columns="columns"
                  :disablePagination="true"
                />
              </div>
            </b-tab>
            <b-tab  v-if="isValidPermission(AR_HSD01)" :title="$t('ar_client_operation_history')">
              <div class="m-3">
                <div class="mb-3 d-flex align-items-center">
                  <b-form-group style="width:200px" :label="$t('ar_common_range')">
                    <WidgetDateTime
                      :placeholder="$t('ar_common_range')"
                      :isRange="true"
                      v-model="range"
                    />
                  </b-form-group>

                  <b-button
                    @click="
                      fetchPaymentHistory({ FromDate: range?.startDate, EndDate: range?.endDate })
                    "
                    class="ml-2"
                    style="margin-top: 16px"
                    variant="primary"
                  >
                    <ez-icon icon="ezAr-icon-search" style="margin-right: 3px" />
                    Tìm kiếm
                    <!-- {{ $t(ar_client_payment_history_search) }} -->
                  </b-button>
                </div>
                <div class="p-1" style="height: 70vh; overflow-y: auto">
                  <AppTimeline v-if="listHistory && listHistory.length > 0">
                    <AppTimelineItem
                      :variant="convertedTransaction(TransactionType)"
                      v-for="(
                        { OldValue, TransactionType, TransactionDate, NewValue,  CreatedBy }, index
                      ) in listHistory"
                      :key="index"
                      :time="dayjs(TransactionDate).format('DD/MM/YYYY HH:mm:ss')"
                      :subtitle="`${$t('ar_client_old_value')}: ${formatPrice(OldValue)}`"
                      :subtitle2="`${$t('ar_client_new_value')}: ${formatPrice(NewValue)}`"
                      :subtitle3="`${$t('ar_client_update_user')}: ${
                         CreatedBy
                      }`"
                      :title="$t(convertTransactionType(TransactionType))"
                    >
                    </AppTimelineItem>
                  </AppTimeline>
                  <div
                    class="d-flex justify-content-center mt-5"
                    style="font-size: 20px; color: #ccc"
                    v-else
                  >
                    {{ $t("ar_client_no_data") }}
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </template>
    </b-sidebar>
  </section>
</template>

<script>
import SidebarLabel from "@/modules/SidebarLabel.vue";
import GeneralInfo from "../../ultils/General/GeneralInfo.vue";
import { formatPrice } from "@/@core/utils/utils";
import WidgetDateTime from "../../ultils/Form/components/DateTime/WidgetDatetime.vue";
import AppTimeline from "@/@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@/@core/components/app-timeline/AppTimelineItem.vue";
import { arClient } from "@/api/ar-client";
import { convertTransactionType } from "../../ultils/status";
import EzTable from "../../ultils/Table/EzTable.vue";
import { AR_UDA01,AR_HSD01 } from "@/api/constant";
import ModalDistributionAccount from "../../ListPayAr/components/ModalDistributionAccount/ModalDistributionAccount.vue";
export default {
  components: {
    "sidebar-label": SidebarLabel,
    EzTable,
    ModalDistributionAccount,
    AppTimeline,
    GeneralInfo,
    WidgetDateTime,
    AppTimelineItem,
  },
  props: {
    detailRowIndex: Number,
    ListDistributionHistory: {
      type: Array,
      default() {
        return [];
      },
    },

    isShow: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
  },
  setup(){
    return {convertTransactionType,AR_UDA01,AR_HSD01}
  },
  data() {
    return {
      isCreateBill:false,
      userData: JSON.parse(localStorage.getItem("userData")),
      range: null,
      tabIndex: 0,
      listAccountClient: [],
      listHistory: [],
      currentShow: 20,
      isModalDistributionAccountVisible: false,

      columns: [
        {
          caption: "ar_client_debit_account_code",
          field: "ArAccountCode",
          width: "25%",
        },
        {
          caption: "ar_client_site_code",
          field: "ArAccountCode",
          cellTemplate: true,
          cellRender(data) {
            return `${data.data.PropertyCode} - ${data.data.PropertyName}`;
          },
        },

        /*  {
          caption: "ar_client_account_credit_limit",
          field: "CreditLimit",
          cellTemplate: true,
          width:"16%",
          formatType: "currency",
        },
        {
          caption: "ar_client_account_credit_limit_day",
          field: "CreditLimitDays",
          cellTemplate: true,
          formatType: "currency",
          width:"16%",
        },
        {
          caption: "ar_client_account_credit_balances",
          field: "CreditBalance",
          cellTemplate: true,
          formatType: "currency",
          width:"16%",
        },
        {
          caption: "ar_client_account_debit_balances",
          field: "DebitBalance",
          cellTemplate: true,
          formatType: "currency",
          width:"16%",
        }, */
        {
          caption: "ar_client_distribution_money_number",
          formatType: "currency",
          cellTemplate: true,
          field: "Amount",
          width: "25%",
          /*  cellRender: (data) => {
            return formatPrice(data.data.Amount);
          }, */
        },
      ],
    };
  },

  methods: {
    convertedTransaction(type) {
      let status = "primary";
      if (type.startsWith("Thanh toán")) {
        status = "success";
      }
      if (type.startsWith("Xóa")) {
        status = "danger";
      }
      return status;
    },
    async fetchPaymentHistory(data) {
      await arClient.api_AR_HSD01({ ...data, DistributionId: this.data?.Id }).then((res) => {
        if (res.Status !== "200") {
          this.showResToast(res);
          return;
        }

        this.listHistory = res.Data.TransactionAccount;
      });
    },
    deleteItem(Id) {
      debugger;
      const deleteDialogRef = this.$parent.$parent.$refs.tableRef.$refs.deleteDialog[0];

      deleteDialogRef.open({
        data: { Id },
      });
    },
    async acceptData_AR_UDA01(value) {
      this.isCreateBill = true
      const body = {
        ...value,
      };
      await arClient.api_AR_UDA01(body).then((res) => {
        this.showResToast(res);
        if(res.Status !== "200"){
          return
        }
        this.isCreateBill = false
        this.isModalDistributionAccountVisible = false;
        this.$emit("fetch-list");
        this.$emit("fetch-detail", { data: { Id: this.data.Id } });
      });
    },
    closeSidebar() {
      this.tabIndex = 0;
      this.$emit("update:isShow", false);
    },
  },

  computed: {
    listGeneral() {
      return [
        {
          icon: "code",
          label: "ar_client_distribution_code",
          content: this.data?.DistributionCode,
        },

        {
          icon: "place",
          label: "ar_voucher_company_name",
          content: this.data?.ArTravelAgentName,
        },
        {
          icon: "user",
          label: "ar_client_cashier",
          content: this.data?.CashierName,
        },
        {
          icon: "calendar",
          label: "ar_client_distribution_date",
          content: this.formatDate(this.data?.DistributionDate),
        },

        {
          icon: "bar-chart",
          label: "ar_client_distribution",
          content: this.data?.DistributionType == "AUTO" ? this.$t("ar_client_auto") : this.$t("ar_client_manual"),
        },
        {
          icon: "dollar-sign",
          label: "ar_client_total_money",
          content:
            this.formatPrice(this.data?.TotalAmountDistribution + this.data?.TotalAmount) +
            " " +
            this.data?.CurrencyCode,
        },

        {
          icon: "note",
          label: "ar_client_account_note",
          top: true,
          content: this.data?.Note,
        },
        {
          icon: "dollar-sign",
          label: "ar_clinent_total_amount_distributed",
          content: this.formatPrice(this.data?.TotalAmount) + " " + this.data?.CurrencyCode,
        },
      ];
    },
    limitedListDistributionHistory() {
      return this.ListDistributionHistory.slice(0, this.currentShow);
    },
    listCurrencyLocalStorage() {
      const localStorageData = JSON.parse(localStorage.getItem("userData"));
      const tempList = [];
      localStorageData?.currency.forEach((c) => {
        tempList.push(c.CurrencyCode);
      });
      return tempList;
    },
  },
  watch: {
    data: {
      handler(v) {
        if (v) {
          this.fetchPaymentHistory();
        }
      },
      deep: true,
    },
    isShow(value) {
      this.$emit("update:isShow", value);
    },
  },
};
</script>
<style lang="scss" scoped>
.divider {
  height: 12px;
  background-color: rgba(193, 193, 193, 0.12);
}
::v-deep .detail-sidebar {
  label {
    display: inline-block;
  }
  label.left-width {
    width: 75px;
  }
  label.right-width {
    width: 120px;
  }
}
.sidebar-view-distribution {
  &__header {
    background: linear-gradient(0deg, rgba(17, 74, 159, 0.12), rgba(17, 74, 159, 0.12)), #ffffff;
  }
  ::v-deep .tabs {
    .nav-tabs {
      background: rgba(193, 193, 193, 0.12);
      li a {
        padding: 13px;
      }
    }
  }
}
</style>
